import React, { createContext, useContext, useState, useEffect } from 'react';
import { branchAPI } from '../api';

const BranchContext = createContext(null);

const DIRECTOR_ROLES = ['director', 'admin'];

export function BranchProvider({ children }) {
  const [selectedBranch, setSelectedBranch] = useState('all');
  const [branches, setBranches] = useState([]);

  const role = sessionStorage.getItem('role');
  const isDirector = DIRECTOR_ROLES.includes(role);

  useEffect(() => {
    const token = sessionStorage.getItem('access_token');
    if (token) {
      branchAPI.getList()
        .then(r => setBranches(r.data))
        .catch(() => {});
    }
  }, []);

  return (
    <BranchContext.Provider value={{ selectedBranch, setSelectedBranch, branches, isDirector }}>
      {children}
    </BranchContext.Provider>
  );
}

export function useBranch() {
  return useContext(BranchContext);
}
